var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('v-form',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('AuctionForm',{ref:"auctionForm",attrs:{"isDisabledSubmit":_vm.isDisabledSubmit},on:{"submit":_vm.submit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }